import React from 'react';
import { useParams } from 'react-router-dom';

import styled from 'styled-components';

export const Container = styled.div`
  text-align: center;
  position: relative;
  padding-bottom: 56.25%;
  padding-top: 30px;
  height: 0;
  overflow: hidden;

  iframe, object, embed {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`;

function WelcomeVideoGuarida() {
  const { partner } = useParams();
  return partner === 'guarida' && (
    <Container>
      <iframe
        width="560"
        height="315"
        src="https://www.youtube.com/embed/kuWOYOlsscI"
        title="Parceria Guarida com Triider"
        frameBorder="0"
        allow="accelerometer;
        autoplay;
        clipboard-write;
        encrypted-media;
        gyroscope;
        picture-in-picture"
        allowFullScreen
      />
    </Container>
  );
}

export default WelcomeVideoGuarida;
